import React, { Component } from 'react';
import api from '../../api';

import List from './question/List';
import Grid from './question/Grid';
import Input from './question/Input';
import Date from './question/Date';
import Versus from './question/Versus';

import { ViewsEnum } from '../constants';

import './Survey.scss';

class Survey extends Component {

    constructor(props) {
        super(props);
        const [firstQuestion] = props.survey.questions;
        this.state = {
            actualQuestion: firstQuestion,
            questions: props.survey.questions,
            translation: props.translation
        }
    }
    
    QuestionScreen(props) {
        switch(props.actualQuestion.style) {
            case 'list':
                return <List {...props} key={props.actualQuestion.id}/>
            case 'grid':
                return <Grid {...props} key={props.actualQuestion.id}/>
            case 'input':
                return <Input {...props} key={props.actualQuestion.id}/>
            case 'date':
                return <Date {...props} key={props.actualQuestion.id}/>
            case 'versus':
                return <Versus {...props} key={props.actualQuestion.id}/>
            default:
                return <div/> 
        }
    }
    
    async pushSelectedAnswers(selectedAnswers) {
        const response = await api.answerQuestion(selectedAnswers, this.state.actualQuestion, this.props.survey.id)
        this.setNextQuestion(response)
    }

    setNextQuestion(response) {
        const searchIndex = this.state.questions.indexOf(this.state.actualQuestion);
        const actualQuestion = this.state.questions[searchIndex + 1];

        if(actualQuestion) {
            this.setState({actualQuestion})
        } else {
            let resObject = { view: ViewsEnum.Goodbay };
            if(response?.has_more_surveys && response?.survey) {
                resObject = { view: ViewsEnum.Survey, survey: response.survey}
            }

            this.props.next(resObject)
        }
    }


    render() {
        return (
            <div className="Survey">
                <this.QuestionScreen {...this.state}  next={ selectedAnswers => this.pushSelectedAnswers(selectedAnswers) }/>
            </div>
        );
    }

}

export default Survey;
